import React from "react";
import { Popover, Tag, Typography, Space } from "antd";

const { Text } = Typography;

type VinPopoverCellProps = {
    value?: string | null;
};

export const VinPopoverCell: React.FC<VinPopoverCellProps> = ({ value }) => {
    if (!value) {
        return null;
    }

    const vins = Array.from(
        new Set(
            value
                .split(",")
                .map((vin) => vin.trim())
                .filter(Boolean)
        )
    );

    const previewText =
        vins.length <= 2 ? vins.join(", ") : `${vins.slice(0, 2).join(", ")} +${vins.length - 2}`;

    const content = (
        <div style={{ maxWidth: 320 }}>
            <Space size={[4, 8]} wrap={true}>
                {vins.map((vin) => (
                    <Tag
                        key={vin}
                        style={{ cursor: "pointer", marginInlineEnd: 0 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard?.writeText(vin);
                        }}
                    >
                        {vin}
                    </Tag>
                ))}
            </Space>
        </div>
    );

    return (
        <Popover
            content={content}
            title={`VIN Number${vins.length > 1 ? "s" : ""} (${vins.length})`}
            trigger="hover"
            placement="topLeft"
        >
            <Text
                ellipsis={true}
                style={{
                    maxWidth: 130,
                    display: "inline-block",
                    cursor: "pointer"
                }}
            >
                {previewText}
            </Text>
        </Popover>
    );
};